/**
 * Pre-Launch Mode Configuration
 *
 * Pre-launch mode can still affect environment-specific behavior, but verified
 * users now continue into the authenticated portal flow where dashboard
 * onboarding decides what they see next.
 */

const normalizeEnvValue = (value?: string): string => value?.trim().toLowerCase() ?? '';

const getRuntimeEnvironment = () => ({
  appEnv: normalizeEnvValue(import.meta.env.VITE_APP_ENV),
  environment: normalizeEnvValue(import.meta.env.VITE_ENVIRONMENT),
  mode: normalizeEnvValue(import.meta.env.MODE),
});

export const isStagingEnvironment = (): boolean => {
  const { appEnv, environment, mode } = getRuntimeEnvironment();
  return appEnv === 'staging' || environment === 'staging' || mode === 'staging';
};

export const PRE_LAUNCH_CONFIG = {
  enabled: import.meta.env.VITE_PRE_LAUNCH_MODE === 'true' && !isStagingEnvironment(),
  boardingUrl: isStagingEnvironment()
    ? 'https://staging.boarding.coordi.me' 
    : 'https://boarding.coordi.me',
};

export const isPreLaunchMode = (): boolean => PRE_LAUNCH_CONFIG.enabled;

export const getBoardingUrl = (): string => PRE_LAUNCH_CONFIG.boardingUrl;

export const getPostVerificationRedirectPath = (isInternalTester = false): string => {
  if (isStagingEnvironment()) {
    return '/login';
  }

  // Keep the internal-tester flag in the centralized redirect decision so
  // future launch gating can branch here without rewiring callers again.
  void isInternalTester;
  return '/dashboard';
};
